(() => {
  const initHomepage = (root) => {
    if (!root || root.dataset.homepageReady === 'true') return;
    const tabs = [...root.querySelectorAll('[data-home-shelf-tab]')];
    const panels = [...root.querySelectorAll('[data-home-shelf-panel]')];
    if (tabs.length !== 5 || panels.length !== 5) return;

    const selectTab = (nextTab, focus = false) => {
      tabs.forEach((tab) => {
        const selected = tab === nextTab;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        const panel = root.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`);
        if (panel) panel.hidden = !selected;
      });
      if (focus) nextTab.focus();
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectTab(tab));
      tab.addEventListener('keydown', (event) => {
        let nextIndex = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === null) return;
        event.preventDefault();
        selectTab(tabs[nextIndex], true);
      });
    });

    const selected = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
    selectTab(selected);
    root.dataset.homepageReady = 'true';
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-electro-homepage]').forEach(initHomepage);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
